<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>每日交易额</span>
      </div>
      <el-form :inline="true" :model="form" :rules="rules" ref="form" size="mini">
        <el-form-item label="应用名称">
          <el-input v-model="form.applyname" placeholder="应用名称"></el-input>
        </el-form-item>
        <el-form-item label="开始日期" prop="start">
          <el-date-picker
            v-model="form.start"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="end">
          <el-date-picker
            v-model="form.end"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="success" @click="excel">EXCEL</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-table :data="list" size="mini">
      <el-table-column prop="applyno" label="应用编号"></el-table-column>
      <el-table-column prop="applyname" label="应用名称"></el-table-column>
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="totalamount" label="交易金额"></el-table-column>
      <el-table-column prop="fscount" label="付费账号数" width="80"></el-table-column>
      <el-table-column prop="arppu" label="ARPPU" width="80"></el-table-column>
      <el-table-column prop="newaccount" label="新增账号数" width="80"></el-table-column>
      <el-table-column prop="nextDayRate" label="新增账号次日留存率">
        <template slot-scope="scope">
          {{ scope.row.nextDayRate }}%
        </template>
      </el-table-column>
      <el-table-column prop="activeaccount" label="活跃账号数" width="80"></el-table-column>
      <el-table-column prop="fsrate" label="付费率" width="80">
        <template slot-scope="scope">
          {{ scope.row.fsrate }}%
        </template>
      </el-table-column>
      <el-table-column prop="oaidcount" label="新增设备数" width="80"></el-table-column>
      <el-table-column prop="activeoaid" label="活跃设备数" width="80"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data () {
    return {
      list: [],
      form:{
        applyname:'',
        start:'',
        end:''
      },
      rules: {
        start: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        end: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ]
      }
    }
  },
  created(){
  },
  methods: {
    query(){
      let _this = this;
      let info = this.$store.state.userInfo;
      this.form.merchno=info.userbh;
      this.$refs.form.validate((valid) => {
        if (valid) {
          _this.$ajax({
            url:"coupon-system/merch/queryDailyMerchSummary",
            data:_this.form,
            async:false,
            methods:"POST",
            success:function(response){
              if (response.code==0) {
                _this.list = response.data || [];
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          })
        } else {
          return false;
        }
      })
    },
    // 下载文件
    download (data) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.target = "_blank";
        link.href = url
        link.setAttribute('download', '每日交易额.xlsx')

        document.body.appendChild(link)
        link.click()
    },
    excel(){
      let info = this.$store.state.userInfo;
      this.form.merchno=info.userbh;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$download('coupon-system/merch/downloadMerchFailedUsingJson',this.form).then((res) => {
            this.download(res)
          }).catch(err => {
            this.$message.error("下载失败");
         })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/merch/daily_merch_summary.vue